import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { employeeHouseVisitsUpdate } from "../../api/server";
import moment from "moment";

export const updateHouseVisits = createAsyncThunk(
  "visits/update",
  async (listParams, thunkAPI) => {
    const { error, data } = await employeeHouseVisitsUpdate(listParams);
    if (error) {
      // thunkAPI.dispatch(notifyError({ title: "Load visits", message: error }));
    }
    return data;
  }
);

const onItemChanged = (state, action) => {
  const changedItem = action.payload.data;
  const { items } = state.page;
  state.page.items = items.map((i) => {
    if (i.id === changedItem.id) {
      return changedItem;
    }
    return i;
  });
};

const initialPageSize = 1000;
const initialState = {
  page: {
    current: 1,
    pageSize: initialPageSize,
    filter: {
      freeText: null,
    },
    order: {
      field: "date",
      order: "ascend",
    },
    items: [],
  },
  activeMonth: moment().format(),
  searchValue: "",
  visitsFilter: "all",
  summary: {},
  summaryParams: null,
};

const visitsSlice = createSlice({
  name: "visits",
  initialState: initialState,
  reducers: {
    setChangedFormItems(state, action) {
      const { changed, values } = action.payload;
      state.settings.changedItems.changed = changed;
      state.settings.changedItems.values = values;
    },
    setMonth(state, action) {
      state.activeMonth = action.payload;
    },
    setSearchValue(state, action) {
      state.searchValue = action.payload;
    },
    setVisitsFilter(state, action) {
      state.visitsFilter = action.payload;
    },
    setSummary(state, action) {
      state.summary = action.payload;
    },
    reset(state, action) {
      state.page = initialState.page;
      state.activeMonth = moment().format();
      state.summary = initialState.summary;
    },
  },
  extraReducers: {
    "houseVisit/update/fulfilled": onItemChanged,
    "houseVisit/delete/fulfilled": (state, action) => {
      const { items } = state.page;
      state.page.items = items.filter((item) => item.id !== action.meta.arg);
    },
  },
});

export const {
  setChangedFormItems,
  setMonth,
  reset,
  setSearchValue,
  setVisitsFilter,
  setSummary,
} = visitsSlice.actions;

export default visitsSlice.reducer;
